import * as React from 'react';

import type { ValuePropItem } from '@coursera-web/cds-labs';

import Markdown from 'bundles/cms/components/Markdown';
import type { ProgramDetailsPanelFragment } from 'bundles/degree-description/__generated__/contentfulTypes';
import LazyCdsIcon from 'bundles/degree-description/components/LazyCdsIcon';

type PanelValuePropsCollection = Pick<
  NonNullable<ProgramDetailsPanelFragment['primaryValuePropsCollection']>,
  'items'
> | null;

/** Converts Contentful program details value props into cards, skipping empty entries. */
const getProgramDetailsValueProps = (
  collection: PanelValuePropsCollection | undefined,
  idPrefix: string
): ValuePropItem[] =>
  (collection?.items ?? []).flatMap((item, index) => {
    if (!item) {
      return [];
    }

    return [
      {
        id: `${idPrefix}-${index}`,
        icon: item.cdsIcon ? <LazyCdsIcon name={item.cdsIcon} size="large" /> : undefined,
        headline: item.heading,
        description: item.description ? <Markdown source={item.description} /> : null,
      },
    ];
  });

export default getProgramDetailsValueProps;
